import React, { useContext, useState, useRef, useEffect } from 'react';
import Button from 'antd/lib/button';
import Upload from 'antd/lib/upload';
import uploadIcon from '../../Images/upload.svg';
import sendIcon from '../../Images/send.svg';

import { 
  CloseCircleOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileImageOutlined,
  FileOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import { downloadFile } from '../../utils/fileUtils';
import { message as antMessage } from 'antd';
import ChatContext from '../../store/ChatContext';
import { getPathFromContext } from '../../utils/pathUtils';
import { Tooltip } from 'antd';


const ChatInput = ({ onSend, className, showPredefinedPrompts = true, isLoading = false }) => {
  const chatCtx = useContext(ChatContext);
  const textareaRef = useRef(null);
  const predefinedPrompts = [
    "Help me with payroll processing",
    "How to handle employee benefits?",
    "Generate a performance review template",
    "What are the latest trends in HR management?",
    "How to handle employee benefits?",
  ];
  
  
  const [messageInput, setMessageInput] = useState('');
  const [fileList, setFileList] = useState([]);

  const handlePromptClick = (prompt) => {
    setMessageInput(prompt);
    const chatInput = document.getElementById('chat-input');
    if (chatInput) {
      chatInput.focus();
    }
  };
  
  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'xlsx':
      case 'xls':
      case 'csv':
        return <FileExcelOutlined className="text-green-600" />;
      case 'pdf':
        return <FilePdfOutlined className="text-red-600" />;
      case 'doc':
      case 'docx':
        return <FileWordOutlined className="text-blue-600" />;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return <FileImageOutlined className="text-purple-600" />;
      case 'txt':
        return <FileTextOutlined className="text-gray-600" />;
      default:
        return <FileOutlined className="text-gray-600" />;
    }
  };

  const handleSend = () => {
    // if(!chatCtx.agentId){
    //   antMessage.error('Please select an agent');
    //   return;
    // }
    if (messageInput.trim() || fileList.length > 0) {
      onSend(messageInput, fileList);
        setMessageInput('');
        setFileList([]);
      }else{
      antMessage.error('Please enter a message or upload a file');
    }
  };

  const removeFile = (fileToRemove) => {
    setFileList(fileList.filter(file => file !== fileToRemove));
  };
  

    const handleBeforeUpload = (file, files) => {
      if (files && files.length > 0) {
        const newFiles = Array.from(files).slice(0, 5);
        setFileList(prevList => {
        const combinedList = [...prevList, ...newFiles];
        const uniqueFiles = combinedList.reduce((acc, current) => {
          const x = acc.find(item => item.name === current.name);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);
        isLoading = false;
        
        return uniqueFiles.slice(0, 5);
      });
    } else {
      setFileList(prevList => {
        if (prevList.find(f => f.name === file.name)) {
          return prevList;
        }
        const newList = [...prevList, file];

        return newList.slice(0, 5);
      });
    }
    return false;
  };

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(textarea.scrollHeight, 200) + 'px'; // Max height of 120px
    }
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [messageInput]);

  return (
    <div className={`relative ${className}`}>
      {/* {fileList.length > 0 && chatCtx.agentId !== 'copilotGraph-001' && ( */}
      {fileList.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-3 px-4">
          {fileList.map((file, index) => (
            <div 
              key={index}
              className="flex items-center gap-2 bg-gray-100 rounded-full px-3 py-1 text-sm cursor-pointer hover:bg-gray-200"
              onClick={() => {
                const contextPath = getPathFromContext(chatCtx);
                downloadFile(file, contextPath);
              }}
            >
              {getFileIcon(file.name)}
              <span className="truncate max-w-[200px]">{file.name}</span>
              <button
                onClick={(e) => {
                  e.stopPropagation(); 
                  removeFile(file);
                }}
                className="hover:bg-gray-300 rounded-full p-1"
              >
                <CloseCircleOutlined className="text-gray-500 hover:text-gray-700" />
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="flex flex-col bg-white rounded-lg  border shadow-sm items-center">
      <textarea
          ref={textareaRef}
          id="chat-input"
          value={messageInput}
          maxLength={3000}
          onChange={(e) => setMessageInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey && !e.altKey && !isLoading) {
              e.preventDefault();
              handleSend();
            }
          }}
          placeholder="I'm here to simplify your work—what's on your mind?"
          className="w-full px-4 py-3 pb-0 outline-none bg-transparent resize-none overflow-auto min-h-[35px] leading-5"
          rows={1}
        />
        <div className="flex justify-end w-full items-center">
        {/* <Tooltip title={fileList.length >= 5 ? "You can only upload 5 files at a time" : "Upload files (PDF, JPG, PNG)"} placement="left">  
        <span className={fileList.length >= 5 ? "cursor-not-allowed" : ""}>
        <Upload
          maxCount={5}
          // className={`p-2 ${chatCtx.agentId === 'copilotGraph-001' ? 'opacity-50 cursor-not-allowed' : ''}`}
          className={`p-2`}
          multiple
          beforeUpload={handleBeforeUpload}
          fileList={[]}
          showUploadList={false}
          accept=".pdf,.jpeg,.jpg,.png,image/jpeg,image/png,image/jpg,application/pdf"
          // disabled={fileList.length >= 5 || chatCtx.agentId === 'copilotGraph-001'} 
          disabled={fileList.length >= 5}  
        >
           <div className="flex items-center">
           <img src={uploadIcon} alt="upload" className="w-4 h-4" />
           <span className="webPortal ml-2">Upload</span>
           </div>
        </Upload>
        </span>
        </Tooltip> */}
       
          <Button
            type="link"
            size="large"
            icon={<img src={sendIcon} alt="send" className={`w-4 h-4 ${messageInput.length === 0 && fileList.length === 0 ? 'opacity-50' : ''}`} />}
            className="!py-2 !h-auto"
            onClick={handleSend}
            disabled={!isLoading && fileList.length === 0 && messageInput.length === 0}

          >
            <span className="webPortal ml-2">Send</span>
          </Button>
          </div>
      </div>

      {false && showPredefinedPrompts && <div className="mt-4 flex flex-wrap gap-2 justify-center">
        {predefinedPrompts.map((prompt, index) => (
          <button
            key={index}
            onClick={() => handlePromptClick(prompt)}
            className="text-sm px-3 py-1.5 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 transition-colors duration-200"
          >
            {prompt}
          </button>
        ))}
      </div>}
    </div>
  );
};

export default ChatInput;
